<template>
  <div>
  <h1 class="title">Funding</h1>
      <table class="table is-fullwidth">
    <thead>
        <tr>
            <th>Date</th>
            <th>Funding Type</th>
            <th>Amount</th>
            <th>Comments</th>
        </tr>
        </thead>
        <tbody>
                <tr valign="top"  v-for="row in fundings" v-cloak v-bind:key="row.id">
                    <td >{{ row.date }}</td>
                    <td >{{row.funding_type_name}}</td>
                    <td>{{row.amount}}</td>
                    <td>{{row.comments}}</td>
                </tr>
                
            </tbody>

        </table>
  </div>
</template>

<script>
  export default {
    props: {
      fundings: {}
    }
  }
</script>
